module.exports = __webpack_public_path__ + "static/img/blood.d6aca5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/organs/blood.png
// module id = 3wdc
// module chunks = 1